<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    // if (!localStorage.getItem("code")) {
    //   this.getCode();
    // }
  },
  data() {
    return {
      code: "",
    };
  },
  methods: {
    getCode() {
      // 非静默授权，第一次有弹框
     
    },
    
  },
};
</script>

<style>
@import url("./style/common.css");
body{
	   height:100%;
	}
#app {
  height:100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.home .van-cell::after {
  left: 0;
}
.home .van-field__label {
  color: #323233;
}
.home .van-checkbox__label {
  margin-left: 3px;
  font-size: 24px;
}
.home .van-checkbox__icon .van-icon {
  width: 30px;
  height: 30px;
}
.home .van-checkbox__icon {
  height: auto;
}
.homes .van-tabs__line {
  background-color: #489fff;
}
.homes .van-tab--active {
  /* color: #ffffff; */
  /* font-weight: bold; */
}
.homes .van-tab {
  /* color: #ffffff; */
  /* font-weight: bold; */
}
.textAlign .van-field__control{
    text-align: right!important;
    background: none!important;
}
.itemMargin .van-icon-success:before{
  position: absolute;
  top: -8px;
  left: 0;
}

.van-field--disabled .van-field__label,.van-field__control:disabled{
  color:#646566!important;
}
.van-field__control:disabled{
      -webkit-text-fill-color: #646566!important;
}
.meets .van-popup{
	width: 80%;
	border-radius: 10px;
	padding: 20px;
}

</style>
